const topicItems = [
  { name: '娱乐圈爆料', count: '12.8万讨论' },
  { name: '网红翻车', count: '9.6万讨论' },
  { name: '明星恋情', count: '8.3万讨论' },
  { name: '综艺内幕', count: '7.1万讨论' },
  { name: '品牌解约', count: '6.5万讨论' },
  { name: '选秀黑幕', count: '5.9万讨论' },
  { name: '私生饭事件', count: '5.2万讨论' },
  { name: '直播事故', count: '4.8万讨论' },
  { name: '互撕大战', count: '4.3万讨论' },
  { name: '偷拍爆料', count: '3.9万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          话题标签
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          当前最热门的51吃瓜讨论话题
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, i) => (
            <div
              key={i}
              className="inline-flex flex-col items-center gap-1 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-colors cursor-pointer"
            >
              <span className="font-heading font-semibold text-sm text-foreground-900 whitespace-nowrap">
                #{item.name}
              </span>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}